<template>
    <div class="page">
        <LoaderProvider>
            <PageProvider>
                <slot />
            </PageProvider>
        </LoaderProvider>
    </div>
</template>

<script setup>
    import LoaderProvider from '~/providers/loader/LoaderProvider.vue';
    import PageProvider from '~/providers/page/PageProvider.vue';
</script>

<style></style>
